"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MaterialType;
(function (MaterialType) {
    MaterialType[MaterialType["PDF"] = 0] = "PDF";
    MaterialType[MaterialType["Video"] = 1] = "Video";
})(MaterialType = exports.MaterialType || (exports.MaterialType = {}));
exports.MaterialTypes = Object.values(MaterialType).filter(function (t) { return typeof t === "number"; });
//# sourceMappingURL=material.js.map